import { AnnualReportMetaInformationDTO } from '@modeso/aumico-lib-annualreport-fe';

export interface IAnnualReportSelectionListData {
    activeAnnualReportId: string;
    annualReports: AnnualReportMetaInformationDTO[];
}
